var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LineChaart',{attrs:{"id":"my-chart-id-2","data":_vm.data,"options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }